import classNames from "classnames";
import {useFormContext} from "react-hook-form";
import {FiSettings} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {AnalyzerCreateFormValues, AnalyzerOptionalSettingsProps} from "@/pages/analyzer/Analyzer.types.ts";
import {hasDivergentOverrides, resolveContactGroupNames} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerSettingsContactsField} from "@/pages/analyzer/components/chat/AnalyzerSettingsContactsField.tsx";
import {AnalyzerSettingsTagsField} from "@/pages/analyzer/components/chat/AnalyzerSettingsTagsField.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerOptionalSettings.module.scss";

export const AnalyzerOptionalSettings = ({className}: AnalyzerOptionalSettingsProps) => {
  const {formData, proposedChecks, creationOutcome} = useAnalyzerContext();
  const {watch, formState} = useFormContext<AnalyzerCreateFormValues>();
  const contactGroups = watch("contactGroups");

  if (!formData) {
    return null;
  }

  const disabled = formState.isSubmitting || (!!creationOutcome && !formState.errors.tags);
  const contactNames = resolveContactGroupNames(contactGroups, formData.contactGroups.items);
  const contactsLocked = hasDivergentOverrides(proposedChecks, contactNames, "contact_groups");

  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.title}>
        <Icon icon={FiSettings} removeDivDimensions />
        Optional settings
      </div>
      <AnalyzerSettingsTagsField disabled={disabled} />
      <AnalyzerSettingsContactsField disabled={disabled} />
      {!contactsLocked && !disabled && !contactGroups.length && (
        <Alert callout="Attention" variant="maintenance" className="mb-0">
          These Checks will not issue Alert notifications until a contact is added.
        </Alert>
      )}
    </div>
  );
};
